var React = require('react');

function Gallery (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"d":"M65.568,29.67L51.693,12.693l-2.289-0.04L34.464,29.67H18.16l-1.5,1.5v55.188l1.5,1.5h63.68l1.5-1.5V31.17l-1.5-1.5H65.568   z M50.491,15.963L61.694,29.67H38.456L50.491,15.963z M80.34,84.857H19.66V32.67h15.482h29.715H80.34V84.857z","key":0}),React.createElement("path",{"d":"M25.15,39.66v38.207l1.5,1.5H73.35l1.5-1.5V39.66l-1.5-1.5H26.65L25.15,39.66z M28.15,41.16H71.85v35.207H28.15V41.16z","key":1})]));
}

Gallery.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 100 125","enableBackground":"new 0 0 100 100","xmlSpace":"preserve"};

module.exports = Gallery;

Gallery.default = Gallery;
